import { createContext } from 'react';

export const VenueContext = createContext(null);
export const VenueProvider = VenueContext.Provider;
